export default "__VITE_ASSET__CB$_ouCQ__"